import UndertakingFormRepository from './undertaking-form-repository'
import { SubmitFormData } from './types'

const useUndertakingFormRepository = () => {
    const repository = new UndertakingFormRepository()

    const retrieveFormConfig = async () => {
        try {
            const config = await repository.getFormConfig()
            return { data: config, error: null }
        } catch (error) {
            console.error(`Repository: Failed to fetch undertaking form config:`, error)
            const errorObj = error instanceof Error ? error : new Error(`Failed to fetch config`)
            return { data: null, error: errorObj }
        }
    }

    const retrieveSubmissionStatus = async () => {
        try {
            const status = await repository.getSubmissionStatus()
            return { data: status, error: null }
        } catch (error) {
            const errorObj = error instanceof Error ? error : new Error(`Failed to fetch status`)
            return { data: null, error: errorObj }
        }
    }

    const submitForm = async (formData: SubmitFormData) => {
        try {
            const response = await repository.submitForm(formData)
            return { data: response, error: null }
        } catch (error) {
            const errorObj = error instanceof Error ? error : new Error(`Failed to submit form`)
            return { data: null, error: errorObj }
        }
    }

    return {
        retrieveFormConfig,
        retrieveSubmissionStatus,
        submitForm,
    }
}

export default useUndertakingFormRepository
